import { AutogenModelBilling, AutogenRowBilling } from "./autogen/AutogenModelBilling";

export class ModelBilling extends AutogenModelBilling<RowBilling> {
	constructor() {
		super(RowBilling);
	}
}

export class RowBilling extends AutogenRowBilling {
}